import _ from 'lodash';

// Product IDs and per-product behaviour used by the builder store.
// Store actions/getters stay the public API; this module holds the branching.

export const PRODUCT = {
  SLIDING: 1,
  WALK_IN: 2,
  KITCHEN: 3,
  CUSTOM_KITCHEN: 4,
  LAUNDRY: 5,
  SLIDING2: 7,
  HINGED: 8,
  CUSTOM: 9
};

export const HINGED_PRODUCT_ID = PRODUCT.HINGED;
export const CONFIG_SECTION_PRODUCT_IDS = [PRODUCT.WALK_IN, PRODUCT.KITCHEN, PRODUCT.LAUNDRY, PRODUCT.SLIDING2];
export const ALL_CONFIG_SECTION_PRODUCT_IDS = [PRODUCT.WALK_IN, PRODUCT.KITCHEN, PRODUCT.LAUNDRY];
export const KITCHEN_LAUNDRY_PRODUCT_IDS = [PRODUCT.KITCHEN, PRODUCT.LAUNDRY];

export function isProductId(productId, ...ids) {
  return ids.some((id) => productId == id);
}

function kitchenCustomWallSpaceWidth(layoutSection, wallSpaceSlug) {
  let wallSpaceWidth = 0;
  if (layoutSection.lhsType == 'end') {
    if (wallSpaceSlug.search('infill-lhs') !== -1) {
      wallSpaceWidth += 30;
    } else {
      wallSpaceWidth += 16;
    }
  }
  if (layoutSection.rhsType == 'end') {
    if (wallSpaceSlug.search('infill-rhs') !== -1) {
      wallSpaceWidth += 30;
    } else {
      wallSpaceWidth += 16;
    }
  }
  return wallSpaceWidth;
}

function hingedWallSpaceWidth(_layoutSection, wallSpaceSlug) {
  let wallSpaceWidth = 0;
  if (wallSpaceSlug.search('infill-lhs') !== -1) {
    wallSpaceWidth += 40;
  } else {
    wallSpaceWidth += 16;
  }
  if (wallSpaceSlug.search('infill-rhs') !== -1) {
    wallSpaceWidth += 40;
  } else {
    wallSpaceWidth += 16;
  }
  return wallSpaceWidth;
}

function walkInWallSpaceWidth(layoutSection, _wallSpaceSlug, item) {
  let wallSpaceWidth = 0;
  const depthValue = parseFloat(item.data.depth.value ?? 587);
  if (layoutSection.lhsType == 'join') {
    wallSpaceWidth += depthValue;
  }
  if (layoutSection.rhsType == 'join') {
    wallSpaceWidth += depthValue;
  }
  return wallSpaceWidth;
}

const defaultStrategy = {
  wallSpaceWidth() {
    return 0;
  },
  usesConfigFeatures: false,
  hasPrepareWhenLevelsOut: false,
  isLegacyProduct: false,
  subtitleFromWallSpace: false,
  describeConfigComponents: false,
  designAlertLabel: null
};

const strategies = {
  [PRODUCT.SLIDING]: {
    ...defaultStrategy,
    isLegacyProduct: true,
    subtitleFromWallSpace: true
  },
  [PRODUCT.WALK_IN]: {
    ...defaultStrategy,
    wallSpaceWidth: walkInWallSpaceWidth,
    describeConfigComponents: true
  },
  [PRODUCT.KITCHEN]: {
    ...defaultStrategy,
    wallSpaceWidth: kitchenCustomWallSpaceWidth,
    usesConfigFeatures: true,
    designAlertLabel: 'kitchen'
  },
  [PRODUCT.CUSTOM_KITCHEN]: {
    ...defaultStrategy,
    wallSpaceWidth: kitchenCustomWallSpaceWidth
  },
  [PRODUCT.LAUNDRY]: {
    ...defaultStrategy,
    usesConfigFeatures: true,
    designAlertLabel: 'laundry'
  },
  [PRODUCT.SLIDING2]: {
    ...defaultStrategy,
    hasPrepareWhenLevelsOut: true,
    describeConfigComponents: true
  },
  [PRODUCT.HINGED]: {
    ...defaultStrategy,
    wallSpaceWidth: hingedWallSpaceWidth,
    describeConfigComponents: true
  },
  [PRODUCT.CUSTOM]: {
    ...defaultStrategy
  }
};

export function strategyFor(productId) {
  return strategies[productId] ?? defaultStrategy;
}

export function getAvailableWidth(section, sectionIndex, item) {
  const userWidth = section.width ?? item.specs.width;

  if (
    !_.isUndefined(userWidth) &&
    !_.isUndefined(item.productLayoutSections) &&
    _.isArray(item.productLayoutSections) &&
    item.productLayoutSections.length &&
    !_.isUndefined(item.data.wallSpace)
  ) {
    const layoutSection = item.productLayoutSections[sectionIndex];
    const wallSpaceSlug = item.data.wallSpace.slug;
    const wallSpaceWidth = strategyFor(item.productId).wallSpaceWidth(layoutSection, wallSpaceSlug, item);
    return userWidth - wallSpaceWidth;
  } else if (!_.isUndefined(item.specs.width)) {
    return item.specs.width;
  }

  return 0;
}

export function quoteAlertForItems(items) {
  let hasAlert = false;
  let alertText = '';

  items.forEach((item) => {
    const label = strategyFor(item.productId).designAlertLabel;
    if (!label) return;

    if (item.specs.requireDesignAppointment) {
      hasAlert = true;
      alertText = '<strong>You\'ve requested a design appointment to help finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
    }
    if (item.specs.requireDesignModifications) {
      hasAlert = true;
      alertText = '<strong>You\'ve requested some design modifications to your ' + label + '.</strong> <br />We\'ll be in touch via email to confirm your quote shortly.';
    }
    if (item.specs.requireDesignAppointment && item.specs.requireDesignModifications) {
      hasAlert = true;
      alertText = '<strong>You\'ve requested some design modifications and a design appointment to finalise your quote.</strong> <br />We\'ll be in touch via email to schedule an appointment shortly.';
    }
  });

  if (hasAlert) alertText += ' <br />Alternatively, <a href="https://calendly.com/diykitchens" target="_blank">schedule your appointment now</a>.';
  if (!hasAlert) alertText = '';

  return alertText;
}
